import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import LdsTabs from "../../components/LdsTabs";
import LdsTabPanel from "../../components/LdsTabs/LdsTabPanel";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import LdsVideoPlayer from "../../components/LdsVideoPlayer";
import LdsFigureCaption from "../../components/LdsFigureCaption";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

export default function Module_2_4_1() {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [currentTab, setCurrentTab] = useState(1);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  const VideoComponent = ({ src }) => {
    return (
      <LdsFigureCaption
        textContent={
          <>
            <p>
              <strong>AUDIO</strong>
              <br />
              VO: (FEMALE)
              <br />
            </p>
            <p>
              <strong>Desktop</strong>
            </p>
            <p>
              When the images first come up, you will see a fusion image in the
              upper left, a CT image if it was done on a PET CT in the lower
              left, and the PET image in the upper right. Multiple tabs are
              often seen here. If you click on the tab that is PT for PET, we
              can get the PET only transaxial view, or the transverse view, in
              the largest resolution.
            </p>
            <p>
              Navigating through these images requires a left click, which will
              reorient the slices, and if you are on the sagittal image for
              instance, and you left click, you can drag the mouse back and
              forth to pan through the coronal or transverse planes. In any
              given view, you can use the scroll wheel to click through each
              image or the arrow keys on your keyboard.
            </p>
            <p>
              The first step is to find the slice with highest levels of image
              contrast. In other words, identify areas of intense uptake of
              Florbetapir, and adjust the contrast appropriately. This button on
              the left side adjusts image contrast. After left clicking on the
              button, hold down the right mouse button and draw a box around the
              areas that are intense in the brain, but include areas outside the
              brain which have a zero value to the pixels. The contrast will
              automatically adjust once you release the right mouse button.
              Sometimes, the adjustment will be very small, and you will not be
              able to see any changes.
            </p>
            <p>
              Go down and adjust the image size by clicking under Zoom images.
              Adjust image size by holding down the left mouse button and moving
              the cursor up or down. Then we go back to the arrow key for
              navigating. Instructions for logging in to the viewer are
              displayed on your screen. Please follow all steps on the screen.
            </p>
            <p>
              <strong>iPad</strong>
            </p>
            <p>
              After you have set up the Mobile MIM app on your iPad, you will
              see the full list of case studies. Tap to select the appropriate
              case study.
            </p>
            <p>
              When the case opens, tap on the Series icon to view the PET image,
              labeled as PT. Tap the Layout icon and select Dominant to view the
              transverse view in the largest screen on the right, with the
              sagittal and coronal views on the left. Use your finger to drag
              the scroll bar on the far right to navigate superiorly or
              inferiorly through the images of the brain.
            </p>
            <p>
              To adjust the image size, use two fingers to enlarge or shrink the
              images as you would normally pinch to zoom in or out on an iPad.
            </p>
            <p>
              Instructions for logging in to the viewer are displayed on your
              screen. Please follow all steps on the screen.
            </p>
          </>
        }
        buttonIcon="MinusCircle"
        buttonTextAlign="left"
        showDescriptionText="Video Transcript"
        hideDescriptionText="Video Transcript"
        radiusSize="small"
      >
        <LdsVideoPlayer brandBorder={false} heading="">
          <iframe
            id="kaltura_player_105125823"
            src={src}
            allowfullscreen
            webkitallowfullscreen
            mozAllowFullScreen
            allow="autoplay *; fullscreen *; encrypted-media *"
          ></iframe>
        </LdsVideoPlayer>
      </LdsFigureCaption>
    );
  };

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">
              2.4.1 MIM Setup and Log-In Instructions
            </h1>
            <p className="me-4">Estimated time to complete: 1-3 minutes</p>
          </section>

          <div className="row mt-5 justify-content-center">
            <div className="col-9">
              <LdsTabs
                id="tabGroup1"
                activeTab={currentTab}
                onChange={(newIndex) => setCurrentTab(newIndex)}
                tabclassName="underlined"
                tabLabels={[
                  { tabId: 1, label: "Desktop" },
                  { tabId: 2, label: "iPad" },
                ]}
              >
                <LdsTabPanel tabId={1} activeTab={currentTab}>
                  <VideoComponent src="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_1926156484&entry_id=1_d7mlj7t9&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true" />

                  <h5 className="b">MIM Referring Setup Instructions</h5>
                  <ol className="ms-0">
                    <li>
                      Please click the appropriate link to download the MIM
                      Referring software.*
                      <ul className="ms-0">
                        <li><a href="https://downloads.mimsoftware.com/MIM7.4.2_buildOA10-09.exe" target="_blank" className="orange b" rel="noreferrer">PC: MIM Referring software download link</a></li>
                        <li><a href="https://downloads.mimsoftware.com/MIM7.4.2_buildOA10-09.dmg" target="_blank" className="orange b" rel="noreferrer">Mac: MIM Referring software download link</a></li>
                      </ul>
                    </li>

                    <li>
                      For PC users, click “Run” to begin the download and follow
                      the installation instructions. For Mac users, click on the
                      downloaded .dmg file and then click on the PKG file to
                      begin the installation.
                      <ul className="ms-0">
                        <li>
                          Use the password “clarke” when prompted to enter a
                          password for the encrypted file
                        </li>
                      </ul>
                    </li>

                    <li>
                      Once the installation completes, click “Close” as you do
                      not need to launch or log into the MIM Referring software
                      at this time.
                    </li>
                    <li>
                      On the following screens, direct links will be provided to
                      cases for your review. If you are prompted for a username
                      and password after clicking on the direct links to the
                      cases, enter
                    </li>
                  </ol>
                  <p>
                    <b>E-mail address:</b> amyvidtraining@amyvidtraining.com
                    <br />
                    <b>Password (case sensitive):</b> Amyvid2012
                  </p>
                  <p className="b">
                    Do not close this training window when you navigate to the
                    MIM Referring software; you will need both windows open at
                    the same time.
                  </p>
                  <p>
                    Please refer to the mobile MIM instructions for iPad on the
                    next page.
                  </p>
                </LdsTabPanel>
                <LdsTabPanel tabId={2} activeTab={currentTab}>
                  <VideoComponent src="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_260571904&entry_id=1_0zs7jexr&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true" />

                  <h5 className="b">Mobile MIM App Setup Instructions</h5>
                  <ol className="ms-0">
                    <li>
                      Please go to the App Store and search “Mobile MIM” to
                      download the Mobile MIM app.
                    </li>
                    <li>
                      After installing the app, follow these steps: <br />
                      <div className="ms-4 flex flex-column">
                        <p>
                          Step 1. Launch the <strong>Mobile MIM</strong> app
                        </p>
                        <p>
                          Step 2. Tap{" "}
                          <strong>Access Non-Diagnostic Mode</strong> and then
                          tap <strong>OK</strong> to skip registration
                        </p>
                        <p>
                          Step 3. Tap <strong>Connect to MIMcloud </strong>
                        </p>
                        <p>
                          Step 4. Enter{" "}
                          <strong>amyvidtraining@amyvidtraining.com</strong> in
                          the <strong>Email Address</strong> field
                        </p>
                        <p>
                          Step 5. Enter <strong>Amyvid2012</strong> in the{" "}
                          <strong>Password</strong> field
                        </p>
                        <p>
                          Step 6. Tap <strong>Log In</strong>
                        </p>
                        <p>
                          Step 7. Tap <strong>MIMcloud</strong>
                        </p>
                      </div>
                    </li>
                  </ol>
                </LdsTabPanel>
              </LdsTabs>
            </div>
          </div>

          <div className="row mt-5 justify-content-center">
            <div className="col-8"></div>
          </div>

          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-3 prev"
              onClick={function navClick() {
                window.open("/module-2/module-2-4-0", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-2/module-2-4-2", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>
          <section></section>
        </main>
      </div>
    </div>
  );
}
